"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class SortModel {
    constructor() {
        this.direction = 'ASC';
    }
}
exports.SortModel = SortModel;
//# sourceMappingURL=SortModel.js.map